import { render, staticRenderFns } from "./boardWarehousingInDetail.vue?vue&type=template&id=ce58537e&scoped=true&"
import script from "./boardWarehousingInDetail.vue?vue&type=script&lang=js&"
export * from "./boardWarehousingInDetail.vue?vue&type=script&lang=js&"
import style0 from "./boardWarehousingInDetail.vue?vue&type=style&index=0&id=ce58537e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce58537e",
  null
  
)

export default component.exports